import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class IndustryField extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.state = {
      query: null
    };
  }

  onChange = (e) => {
    let selected = this.selectRef.current.value;
    //update filters in redux
    this.props.updateFilterSelected('industry', selected);
    this.props.postUpdated('asc', selected, this.props.data, 'industry');
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filters.clear_filter.active) {
      this.clearField();
    }
    if (this.props.query && this.props.query.industry && prevState.query === null) {
      // decode and replace &amp; because the data is poor
      //let decodedQuery = decodeURIComponent(this.props.query.industry).replace('&amp;', '&');
      //this.setState({ query: decodedQuery });
      //this.selectRef.current.value = decodedQuery;
      this.props.updateFilterSelected('industry', this.props.query.industry);
      this.props.postUpdated('asc', this.props.query.industry, this.props.data, 'industry');
    }
  }

  clearField() {
    this.selectRef.current.value = '';
  }

  render() {
    return (
      <select className="form-control" ref={this.selectRef} onChange={this.onChange}>
        <option value="">Industry</option>
        <option value="chemistry-chemical-engineering">Chemistry + Chemical Engineering</option>
        <option value="electrical-computer-technologies">
          Electrical + Computer Technologies
        </option>
        <option value="internet-e-commerce-business-methods">
          Internet, E-Commerce + Business Methods
        </option>
        <option value="life-sciences-pharmaceuticals">Life Sciences + Pharmaceuticals</option>
        <option value="medical-devices">Medical Devices</option>
      </select>
    );
  }
}

IndustryField.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = (dispatch) => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = (state) => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndustryField);
